import template from './mergeDocuments.template.html';

export default {
  bindings: {
    onFinished: '&'
  },
  controller: class controller {
    constructor($mdDialog, $mdMedia, eventService, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdDialog = $mdDialog;
      ctrl.$mdMedia = $mdMedia;
      ctrl.destroyWatch = null;

      this.initialize = () => {
        ctrl.destroyWatch = eventService.onMergeDocuments((params) => {
          $mdDialog
            .show({
              targetEvent: params.event,
              locals: {
                complianceFileLabels: params.complianceFileLabels || [],
                documents: params.documents || [],
                specificDocuments: params.specificDocuments || [],
                lenders: params.lenders || [],
                validationErrors: params.validationErrors || [],
                ticket: params.ticket || {},
                workflow: params.workflow || {},
                assetFinance: params.assetFinance || {},
                homeLoan: params.homeLoan || {},
                hasAssetFinanceTools: params.hasAssetFinanceTools || false,
                hasHomeLoanTools: params.hasHomeLoanTools || false,
                showPdfService: params.showPdfService || false,
                showSpecificDocuments: params.showSpecificDocuments || false
              },
              template,
              controllerAs: '$ctrl',
              controller(
                complianceFileLabels,
                documents,
                specificDocuments,
                lenders,
                validationErrors,
                ticket,
                workflow,
                assetFinance,
                homeLoan,
                hasAssetFinanceTools,
                hasHomeLoanTools,
                showPdfService,
                showSpecificDocuments
              ) {
                const ctr = this;
                ctr.mergeDocuments = [];
                ctr.complianceFileLabels = complianceFileLabels;
                ctr.documents = documents;
                ctr.specificDocuments = specificDocuments;
                ctr.lenders = lenders;
                ctr.validationErrors = validationErrors;
                ctr.ticket = ticket;
                ctr.workflow = workflow;
                ctr.assetFinance = assetFinance;
                ctr.homeLoan = homeLoan;
                ctr.hasAssetFinanceTools = hasAssetFinanceTools;
                ctr.hasHomeLoanTools = hasHomeLoanTools;
                ctr.showPdfService = showPdfService;
                ctr.showSpecificDocuments = showSpecificDocuments;
                ctr.availableClientTypesForCreateDocumentsOption = helperService.getAvailableClientTypesForCreateDocumentsOption();
                ctr.clientTypeOption =
                  ctr.availableClientTypesForCreateDocumentsOption[0]?.id || '';

                ctr.selectedDocuments = (mergeDocuments) => {
                  ctr.mergeDocuments = mergeDocuments;
                };

                ctr.confirm = () => {
                  $mdDialog.hide({
                    documents: ctr.mergeDocuments,
                    isSpecific: ctr.showSpecificDocuments,
                    filterByContact: ctr.clientTypeOption
                  });
                };
                ctr.cancel = () => {
                  $mdDialog.cancel();
                };
              }
            })
            .then((result) => {
              ctrl.onFinished({ data: result });
            });
        });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
